module.exports = __webpack_public_path__ + "img/icon-census-green.f1d921c5.svg";